import { gql } from '@apollo/client';

export const GET_REPLICATION_ROWS = gql`
  query GetReplicationRows($input: GetReplicationRowsRequest!) {
    getReplicationRows(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        id
        data
      }
    }
  }
`;
